import { render, staticRenderFns } from "./PhonesStore.vue?vue&type=template&id=c4bf2ce0"
import script from "./PhonesStore.vue?vue&type=script&lang=js"
export * from "./PhonesStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports